export const commaNumber = (input?: number | string, min = 0, max = 2) => {
  return input
    ? `${input.toLocaleString(undefined, {
        minimumFractionDigits: min,
        maximumFractionDigits: max,
      })}`
    : input;
};
